module.exports = __webpack_public_path__ + "img/social-media-marketing-landing.8b78a9c2.webp";